import _ from 'lodash';

export class TreeMapData {
  constructor(state) {
    this._init(state);
  }

  _init(state) {
    const {title, name, type, data, groups, category, columns} = state;

    const columnFilter = column => !column.hidden;
    const dataModel = _.filter([category].concat(columns), columnFilter);
    const valueField = _.find(columns, c => _.snakeCase(c.title) === _.snakeCase(groups.value)).field;

    const createItems = (items, subItems) => {
      const groupBy = subItems[0];
      if (groupBy) {
        return _(items)
            .groupBy(groupBy)
            .map((value, key) => ({
              name: key,
              value: _.sumBy(value, groups.value),
              items: createItems(value, _.slice(subItems, 1))
            }))
            .value();
      }

      return _.map(items, i => _.assign({
        name: i[category.field],
        value: i[valueField]
      }, i));
    };

    const dataSource = [{
      name: groups.title,
      value: _.sumBy(data, valueField),
      items: createItems(data, groups.sub)
    }];

    this.dataModel = dataModel;
    this.dataSource = dataSource;
    this.name = name;
    this.title = title;
    this.type = type;
  }
}
